import { useState, useRef, useEffect } from "react";
import { Download } from "lucide-react";
import { exportRows } from "../lib/exports";

/**
 * Dropdown button that lets the admin download the given rows
 * as CSV / Excel / PDF.
 * Usage:  <ExportButton rows={data} name="orders" title="TileRoom Orders" />
 */
export default function ExportButton({ rows, name, title, disabled = false, testId }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const doExport = (fmt) => {
    setOpen(false);
    exportRows(rows || [], name, fmt, title || name);
  };

  return (
    <div className="relative inline-block" ref={ref} data-testid={testId || `export-${name}`}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-[0.15em] border border-[#1E2C5A] text-[#1E2C5A] bg-white hover:bg-[#1E2C5A] hover:text-white transition-colors disabled:opacity-50"
        data-testid={`${testId || `export-${name}`}-toggle`}
      >
        <Download className="w-3.5 h-3.5" strokeWidth={1.5} /> Export
      </button>
      {open && (
        <div className="absolute right-0 mt-1 bg-[#FAF9F6] border border-[#1A1A1A]/15 shadow-lg z-30 min-w-[140px]" data-testid={`${testId || `export-${name}`}-menu`}>
          <button onClick={() => doExport("csv")} className="block w-full text-left px-4 py-2 text-xs hover:bg-[#F0EFEA] uppercase tracking-wider" data-testid={`${testId || `export-${name}`}-csv`}>CSV</button>
          <button onClick={() => doExport("xlsx")} className="block w-full text-left px-4 py-2 text-xs hover:bg-[#F0EFEA] uppercase tracking-wider" data-testid={`${testId || `export-${name}`}-xlsx`}>Excel</button>
          <button onClick={() => doExport("pdf")} className="block w-full text-left px-4 py-2 text-xs hover:bg-[#F0EFEA] uppercase tracking-wider" data-testid={`${testId || `export-${name}`}-pdf`}>PDF</button>
        </div>
      )}
    </div>
  );
}
